"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _CurrencyHelper = _interopRequireDefault(require("../../util/CurrencyHelper"));

var _index = require("../../index");

var _BaseModel2 = _interopRequireDefault(require("../../logic/model/BaseModel"));

var _core = require("@material-ui/core");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

function _typeof(obj) {
  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}

function _possibleConstructorReturn(self, call) {
  if (call && (_typeof(call) === "object" || typeof call === "function")) {
    return call;
  }

  return _assertThisInitialized(self);
}

function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf(subClass, superClass);
}

function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf(o, p);
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

var UnloadForm = /*#__PURE__*/function (_React$Component) {
  _inherits(UnloadForm, _React$Component);

  function UnloadForm(props) {
    var _this;

    _classCallCheck(this, UnloadForm);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(UnloadForm).call(this, props));

    _defineProperty(_assertThisInitialized(_this), "formHandler", void 0);

    _this.formHandler = new _index.FormHandler(_assertThisInitialized(_this), new UnloadModel({
      id: props.card.id,
      amount: 0,
      text: 'Unload'
    }));
    return _this;
  }

  _createClass(UnloadForm, [{
    key: "_onSuccess",
    value: function _onSuccess() {
      this.props.close();
      this.props.onLoad();
    }
  }, {
    key: "_getActionButtons",
    value: function _getActionButtons(loading) {
      return _react["default"].createElement("div", {
        style: {
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          marginTop: 20
        }
      }, _react["default"].createElement("button", {
        onClick: this.props.close,
        className: "button-info"
      }, "Cancel"), _react["default"].createElement("button", {
        type: "submit",
        className: "button-info"
      }, loading ? _react["default"].createElement(_core.CircularProgress, {
        className: "circle-progress",
        size: 20
      }) : 'Submit'));
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var formHandler = this.formHandler;
      return _react["default"].createElement("div", {
        style: {
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          flexDirection: 'column'
        }
      }, _react["default"].createElement("p", {
        style: {
          textAlign: 'center',
          paddingBottom: 20
        }
      }, "Please provide amount and ", _react["default"].createElement("b", null, "unload"), " description"), _react["default"].createElement("div", {
        style: {
          width: '50%',
          marginBottom: 20
        }
      }, _react["default"].createElement(_index.FormSubmitWrapper, {
        formHandler: formHandler,
        renderActionButtons: function renderActionButtons(loading) {
          return _this2._getActionButtons(loading);
        },
        onSuccess: function onSuccess() {
          return _this2._onSuccess();
        }
      }, _react["default"].createElement(_index.InputField, {
        materialProps: {
          fullWidth: true
        },
        InputLabelProps: {
          shrink: true
        },
        customInput: _core.TextField,
        label: "Amount",
        type: "number",
        name: "amount",
        value: this.state.record.amount,
        handler: formHandler
      }), _react["default"].createElement(_index.InputField, {
        materialProps: {
          fullWidth: true
        },
        InputLabelProps: {
          shrink: true
        },
        label: "Text",
        type: "text",
        name: "text",
        value: this.state.record.text,
        handler: formHandler
      }))));
    }
  }]);

  return UnloadForm;
}(_react["default"].Component);

exports["default"] = UnloadForm;

var UnloadModel = /*#__PURE__*/function (_BaseModel) {
  _inherits(UnloadModel, _BaseModel);

  function UnloadModel() {
    _classCallCheck(this, UnloadModel);

    return _possibleConstructorReturn(this, _getPrototypeOf(UnloadModel).apply(this, arguments));
  }

  _createClass(UnloadModel, [{
    key: "getSubmitUrl",
    value: function getSubmitUrl() {
      return 'payment-device/unload';
    }
    /**
     * Get validation rules
     */

  }, {
    key: "getValidationRules",
    value: function getValidationRules() {
      return {
        amount: {
          presence: {
            message: '^Please enter amount'
          },
          numericality: {
            greaterThan: 0,
            message: '^Please enter a value greater than 0'
          }
        },
        text: {
          presence: {
            message: '^Please enter transaction message'
          }
        }
      };
    }
  }]);

  return UnloadModel;
}(_BaseModel2["default"]);